import React from 'react';
import ReactDOM from 'react-dom';
import { create } from 'axios';

import App from 'src/App';
import buildStore from 'src/redux/store';

// eslint-disable-next-line import/no-unassigned-import
import '@grupa-pracuj/react-loader/dist/index.css';

const bootstrapApplication = ({ libraryName, baseURL, timeout }) => {
  const root = document.querySelector(`#${libraryName}-markup`);
  if (!root) return false;

  const headers = {
    'x-app-name': window.GP_APP_NAME,
    'x-app-version': window.GP_APP_VERSION,
  };

  const http = create({
    headers,
    baseURL,
    withCredentials: true,
    timeout,
  });

  const store = buildStore({
    name: libraryName,
    middlewares: {
      http,
    },
    state: window[`${libraryName}`],
  });

  return ReactDOM.hydrate(<App store={store} />, root);
};

export default bootstrapApplication;
